import { WellmaxxTemplateDefault } from './WellmaxxTemplateDefault'

export default WellmaxxTemplateDefault
